module.exports = __webpack_public_path__ + "giving/public/shared/assets/visa.svg?b0fcc2d8e489eaa8f0ad8a0d5e8cfffd";